import { getCaptchaToken } from '@/lib/turnstile';

import { toApiError } from '../ApiError';
import { CAPTCHA_ACTIONS, postPublicSubmission } from '../publicSubmission';

import { type AccessoryOrderInput, type AccessoryOrderReceipt } from './types';

/**
 * Places an accessory order. Prices are never sent: `submit_accessory_order`
 * reads them from the catalogue and validates everything again. Covered by the
 * captcha for the same reason as car orders.
 */
export async function submitAccessoryOrder(
  input: AccessoryOrderInput,
): Promise<AccessoryOrderReceipt> {
  try {
    const captchaToken = await getCaptchaToken(CAPTCHA_ACTIONS.accessoryOrder);
    const { reference_no } = await postPublicSubmission<{ reference_no: string }>(
      'submit-checkout',
      {
        kind: 'accessory_order',
        payload: {
          full_name: input.fullName,
          phone: input.phone,
          email: input.email,
          message: input.message ?? null,
          items: input.items,
          page_path: input.pagePath ?? null,
          company_website: input.companyWebsite ?? null,
        },
        captcha_token: captchaToken,
      },
    );
    return { referenceNo: reference_no };
  } catch (error) {
    throw toApiError(error);
  }
}
